<template>
  <div align="center" class="container-fluid">
    <page-header></page-header>
    <div class="navbar_website_map">
      <img src="../../assets/img/jt.jpg" width="9" height="9" />
      {{ $t("currlocation") }}:
      <router-link :to="{ name: 'login' }">{{ $t("index") }}</router-link>
      <img src="../../assets/img/jt.gif" /><a href="javascript:history.go(-1)">{{ $t("anonymou_currpage") }}</a>
      <img src="../../assets/img/jt.gif" />{{ $t("anonymoudetail_title") }}
    </div>
    <div style="min-height: 450px;">
      <!--正文表格开始-->
      <table class="table">
        <tbody>
          <tr>
            <td width="20%" align="left"><b>{{$t("anonymou_house_no")}}:</b> &nbsp; {{mainInfo.houseNo}}</td>
            <td width="13%" align="left"><b>{{$t("anonymou_orgn_code")}}:</b> &nbsp; {{mainInfo.orgnCode}}</td>
            <td width="13%" align="left"><b>{{$t("anonymou_dest_code")}}:</b> &nbsp; {{mainInfo.destCode}}</td>
            <td width="13%" align="left"><b>{{$t("anonymou_qty" )}}:</b> &nbsp; {{mainInfo.qty}}</td>
            <td width="13%" align="left"><b>{{$t("anonymou_gw" )}}:</b> &nbsp; {{mainInfo.gw}}</td>
            <td width="13%" align="left"><b>{{$t("anonymou_cw" )}}:</b> &nbsp; {{mainInfo.cw}}</td>
            <td width="15%"></td>
          </tr>
        </tbody>
      </table>

      <table-no-record v-if="records.length == 0"></table-no-record>
      <table v-if="records.length > 0" class="table table-bordered table-hover">
        <!--DWLayoutTable-->
        <thead>
          <tr class="trtitle">
            <th width="42%" height="20" valign="middle">{{$t('anonymoudetail_statedetail')}}</th>
            <th width="18%">{{$t('anonymoudetail_state')}}</th>
            <th width="40%">{{$t('anonymoudetail_remake')}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(record,index) in records" :key="index">
            <td height="18" valign="middle">
              {{getStateNameLocalLanguage(record)}}
            </td>
            <td valign="middle">
              {{record.stateDate}}&nbsp;{{record.stateTime}}
            </td>
            <td valign="middle">{{record.remark}}</td>
          </tr>
        </tbody>
      </table>
      <pagination v-if="records.length > 0" :total="total" @current-change="changePage" :pageSize="50" :current-page="currentPage"></pagination>
    </div>
    <page-footer></page-footer>
  </div>
</template>
<script>
import PageFooter from "@/components/infrastructure/layout/page-footer.vue";
import PageHeader from "@/components/infrastructure/layout/page-header.vue";
import TableNoRecord from "@/components/infrastructure/table/table-no-record.vue";
import Pagination from "@/components/infrastructure/pagination/index.vue";
import { getBillOfLadingRecordDetail } from "@/api/airwayBill";
export default {
  components: {
    PageHeader,
    PageFooter,
    TableNoRecord,
    Pagination,
  },
  data() {
    return {
      mainInfo: {},
      records: [],
      total: 0,
      currentPage: 1,
      houseNo: "",
    };
  },
  mounted() {
    this.mainInfo = JSON.parse(this.$route.query.info);
    this.houseNo = this.$route.params["houseNo"];
    this.query();
  },
  methods: {
    //获取状态名称本地语言
    getStateNameLocalLanguage(record) {
      var lang = this.$store.getters.lang;
      var state = {
        en: record.stateEname,
        "zh-cn": record.stateSname,
        "zh-tw": record.stateCname,
      };
      return state[lang];
    },
    changePage(page) {
      if (this.currentPage == page) {
        return;
      }
      this.currentPage = page;
      this.query();
    },
    async query() {
      if (this.$utils.isNullOrEmpty(this.houseNo)) {
        return;
      }
      var self = this;
      await getBillOfLadingRecordDetail({
        houseNo: this.houseNo,
        page: this.currentPage,
        row: 50,
      })
        .then((res) => {
          if (res.message) {
            alert(res.message);
          } else {
            self.records = res.data.listTo;
            self.total = res.data.totalLength;
            window.scrollTo(0, 0);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>